import {Observable} from 'rxjs';
import {jobHunterAPI} from './provider/jobHunterAPI';
import {RestQueryParams} from './base/queryParams';

export function postMessageReadConfirmationAPI(accessToken: string, messages: string[]): Observable<any> {
    return jobHunterAPI.post(`api/messages/mark_chat_messages_as_read`, {ids: messages}, new RestQueryParams(), {
        Authorization: `Bearer ${accessToken}`,
    });
}
